import getPermissions from './getPermissions';
import loginByIdentityToken from './loginByIdentityToken';
import getRefreshToken from './refreshToken';
import setUserType from './setUserType';
import login from './login';

const operations = {
  loginByIdentityToken,
  getPermissions,
  getRefreshToken,
  setUserType,
  login
};

export default operations;

